// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__nXhRZ","item":"PaymentsMobile_item__YzRZf","label":"PaymentsMobile_label__mgrjG","amount":"PaymentsMobile_amount__3-DCj"};